import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserProfileDetailsComponent } from './user-profile-details.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { PhoneNumberFormatModule } from 'src/app/libs/ui/pipes/phone-number-format/phone-number-format.module';
import { SharedLayoutModule } from 'src/app/shared-layout/shared-layout.module';
import { SameUserIdControlDirectiveModule } from 'src/app/libs/ui/directives/same-userid-control/same-userid-control-directive.module';
import { ProfilePictureModule } from 'src/app/shared-layout/Components/profile-picture/profile-picture.module';
import { WithTooltipModule } from 'src/app/shared-layout/Components/with-tooltip/with-tooltip.module';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [UserProfileDetailsComponent],
  imports: [
    CommonModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    FormsModule,
    MatSlideToggleModule,
    MatIconModule,
    PhoneNumberFormatModule,
    SharedLayoutModule,
    WithTooltipModule,
    SameUserIdControlDirectiveModule,
    ProfilePictureModule,
    TranslateModule
  ],
  exports: [UserProfileDetailsComponent],
  providers: [
    LocalizationService,
    TranslateModule
  ]
})
export class UserProfileDetailsModule {}
